import { render, staticRenderFns } from "./CmgRetroCreditMessage.vue?vue&type=template&id=20068419&scoped=true&lang=pug"
import script from "./cmg-retro-credit-message.ts?vue&type=script&lang=ts&external"
export * from "./cmg-retro-credit-message.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRetroCreditMessage.vue?vue&type=style&index=0&id=20068419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20068419",
  null
  
)

export default component.exports